import { object, string } from 'yup';

import { validationErrMessages } from '@constants/validationConstants';

export const baseSchema = object({
	technology: object().nullable().required(validationErrMessages.technology),
	band: object().nullable().required(validationErrMessages.band),
	radius: string()
		.required(validationErrMessages.radius),
	beamwidth: string()
		.required(validationErrMessages.beamwidth),
	colorId: string(),
});
